import {createContext} from "react";

export const AlertContext = createContext({
    title: "",
    content: "",
    severity: "",
    open: false,
    setContext: (context)=>{}
});
